import { useMemo } from 'react';
import { cx } from '@/utils';
import { t } from '@lingui/macro';
import { DialogBody, DialogFooter, DialogHeader } from '@material-tailwind/react';

import { useModalDialogCustomStore } from '@/utils/store/store';

import { ButtonWithLogo } from '../ButtonWithLogo/ButtonWithLogo';
import SvgCheckCircle from '../Icons/CheckCircle';
import CrossIcon from '../Icons/CrossIcon';
import SvgExclamationCircle from '../Icons/ExclamationCircle';
import Modal from './Modal';

const SUCCESS = 'success';
const ERROR = 'error';
//const INFO = "info";
const CREATE = 'create';

const ModalDialogCustom = () => {
  const {
    modalVisible,
    showVisible,
    title,
    message,
    type,
    onConfirm,
    confirmBtnLabel = 'Confirmar',
    cancelBtnLabel = 'Cancelar',
  } = useModalDialogCustomStore();

  const styles = useMemo(() => {
    switch (type) {
      case ERROR:
        return {
          textColor: '!text-redDark',
          btnColor: '!bg-redDark !hover:bg-red-900',
          cancelBtnColor: '!text-redDark !border-redDark !hover:bg-redDark',
          icon: <SvgExclamationCircle width={60} height={60} className="text-redDark" />,
        };
      case SUCCESS:
        return {
          textColor: '!text-elfGreen',
          btnColor: '!bg-elfGreen !hover:bg-greenDark',
          cancelBtnColor: '!text-elfGreen !border-elfGreen !hover:bg-elfGreen',
          icon: <SvgCheckCircle width={60} height={60} className="text-elfGreen" />,
        };

      case CREATE:
        return {
          textColor: '!text-elfGreen',
          btnColor: '!bg-elfGreen !hover:bg-greenDark',
          cancelBtnColor: '!text-elfGreen !border-elfGreen !hover:bg-elfGreen',
          icon: <CrossIcon width={60} height={60} className="text-elfGreen" />,
        };

      default: {
        return {
          textColor: '!text-marine',
          btnColor: '!bg-marine !hover:bg-blueDark',
          cancelBtnColor: '!text-marine !border-blueDark !hover:bg-blueDark',
          icon: <SvgExclamationCircle width={60} height={60} className="text-marine" />,
        };
      }
    }
  }, [type]);

  const closeModal = () => showVisible({ modalVisible: false });

  return (
    <>
      <Modal
        open={modalVisible}
        handler={showVisible}
        dismiss={{
          escapeKey: false,
          outsidePress: false,
          referencePress: false,
          enabled: false,
        }}
        className="py-8"
        style={{ zIndex: 'var(--z-modal)' }}
      >
        <DialogHeader className="flex flex-col justify-center gap-[20px] pb-0">
          {styles.icon}
          <label
            className={cx(
              styles.textColor,
              'font-montserrat text-[32px] font-semibold leading-[36px]'
            )}
          >
            {title}
          </label>
        </DialogHeader>
        <DialogBody className="flex flex-col items-center pt-5 text-center font-workSans">
          <label className={'font-workSans text-[16px] font-normal leading-[21px] text-tundora'}>
            {message}
          </label>
        </DialogBody>
        <DialogFooter className="items-center justify-evenly">
          <ButtonWithLogo
            onClick={closeModal}
            logo={null}
            nameButton={cancelBtnLabel}
            className={cx(
              'w-[165px] justify-center bg-white font-[500] hover:text-white',
              styles.cancelBtnColor
            )}
          />
          <ButtonWithLogo
            onClick={onConfirm}
            logo={null}
            nameButton={confirmBtnLabel}
            className={cx('w-[165px] justify-center font-[500] text-white', styles.btnColor)}
          />
        </DialogFooter>
      </Modal>
    </>
  );
};

export default ModalDialogCustom;
